import { blue, ColorScale, purple } from 'bold-ui/lib/styles/colors'
import { TipoAcompanhamentoEnum } from 'graphql/types.generated'
import preNatalIcon from 'images/historico/icone-pre-natal.svg'
import puerperioIcon from 'images/historico/icone-puerperio.svg'

import { ACOMPANHAMENTOS_URL } from './AcompanhamentosView'

export const ACOMPANHAMENTOS_PRE_NATAL_URL = `${ACOMPANHAMENTOS_URL}/pre-natal`
export const ACOMPANHAMENTOS_PUERPERIO_URL = `${ACOMPANHAMENTOS_URL}/puerperio`

interface AcompanhamentosSideMenuItemsProps {
  isPreNatalVisible: boolean
  isPuerperioVisible: boolean
  isVinculacaoCuidadoEnabled: boolean
  hasCboAuth: boolean
}

export interface AcompanhamentoSideMenuItem {
  title: AcompanhamentoMenuTitle
  icon: string
  alt: string
  color: ColorScale
  url: string
  subItems: ReadonlyArray<{ title: string; to: string }>
  /* TODO @RoyalFlush: A principio, a flag isVisible só é utilizada para não deixar o menu do acompanhamento de Puerpério ser renderizado,
  pois ainda não tem integração com o acompanhamento do Pré-natal. Futuramente, rever se há necessidade uma flag booleana, ou alguma outra
  forma de controle de renderização dos menus. */
  isVisible: boolean
}

export type AcompanhamentoMenuTitle = 'Pré-natal' | 'Puerpério'

export const getAcompanhamentosSideMenuItems = (
  props: AcompanhamentosSideMenuItemsProps
): Record<TipoAcompanhamentoEnum, AcompanhamentoSideMenuItem> => {
  const getEncaminhamentosSubItems = () => {
    if (!props.hasCboAuth) {
      return []
    }
    // TODO @RoyalFlush (#32854) Excluir a verificação e manter apenas o primeiro subitem quando os encaminhamentos forem unificados
    if (props.isVinculacaoCuidadoEnabled) {
      return [
        {
          title: 'Encaminhamento/Compartilhamento de cuidado',
          to: '#encaminhamentos-compartilhamento-cuidado',
        },
      ]
    }

    return [
      {
        title: 'Encaminhamentos',
        to: '#encaminhamentos',
      },
    ]
  }

  return {
    [TipoAcompanhamentoEnum.PRE_NATAL]: {
      title: 'Pré-natal',
      icon: preNatalIcon,
      alt: 'Ícone de uma mulher grávida',
      color: purple,
      url: ACOMPANHAMENTOS_PRE_NATAL_URL,
      isVisible: props.isPreNatalVisible,
      subItems: [
        {
          title: 'Antecedentes obstétricos',
          to: '#antecedentes-obstetricos',
        },
        {
          title: 'Informações da gestação atual',
          to: '#informacoes-gestacao-atual',
        },
        {
          title: 'Acompanhamento de vulnerabilidades',
          to: '#acompanhamento-vulnerabilidade',
        },
        {
          title: 'Medições da gestante',
          to: '#medicoes-gestante',
        },
        {
          title: 'Medicamentos em uso',
          to: '#medicamentos-em-uso',
        },
        {
          title: 'Lista de problemas e condições',
          to: '#lista-problemas-condicoes',
        },
        {
          title: 'Problemas/condições autorreferidas',
          to: '#condicoes-autorreferidas',
        },
        {
          title: 'Últimos contatos',
          to: '#ultimos-contatos',
        },
        {
          title: 'Vacinação',
          to: '#vacinacao',
        },
        {
          title: 'Exames',
          to: '#exames-pre-natal',
        },
        ...getEncaminhamentosSubItems(),
        {
          title: 'Próximo(s) agendamento(s)',
          to: '#proximos-agendamentos',
        },
      ],
    },
    [TipoAcompanhamentoEnum.PUERPERIO]: {
      title: 'Puerpério',
      icon: puerperioIcon,
      alt: 'Ícone de uma mulher em puerpério',
      color: blue,
      url: ACOMPANHAMENTOS_PUERPERIO_URL,
      isVisible: props.isPuerperioVisible,
      subItems: [
        {
          title: 'Informações do puerpério',
          to: '#informacoes-puerperio',
        },
        {
          title: 'Medições do puerpério',
          to: '#medicoes-puerperio',
        },
        {
          title: 'Lista de problemas e condições',
          to: '#lista-problemas-condicoes',
        },
        {
          title: 'Medicamentos em uso',
          to: '#medicamentos-em-uso',
        },
        {
          title: 'Últimos contatos',
          to: '#ultimos-contatos',
        },
        {
          title: 'Acompanhamento de vulnerabilidades',
          to: '#acompanhamento-vulnerabilidade',
        },
        {
          title: 'Vacinação',
          to: '#vacinacao',
        },
        {
          title: 'Exames realizados no puerpério',
          to: '#exames-puerperio',
        },
        ...(props.isVinculacaoCuidadoEnabled
          ? [
              {
                title: 'Encaminhamento/Compartilhamento de cuidado',
                to: '#encaminhamentos-compartilhamento-cuidado',
              },
            ]
          : []),
        {
          title: 'Próximo(s) agendamento(s)',
          to: '#proximos-agendamentos',
        },
      ],
    },
  }
}
